import { analyticsConstants } from "../constants/ActionTypes";
import { baseUrl } from '../constants/baseUrl';

export const getUniqueCustomersAction = (paramObj, onSuccess, onFailure) => ({
    type: analyticsConstants.GET_UNIQUE_CUSTOMERS,
    payload: paramObj,
    meta: {
        type: 'api', //use apijson for returning json objects, and api for returning strings
        url: baseUrl + '/unique_customers',
        onSuccess: onSuccess,
        onFailure: onFailure,
        params: {
            shop_id: paramObj.shopId,
        },
        options: {
            method: 'GET'
        }
    }
})